// import { useNavigate } from 'react-router-dom';
import solutions from '../content/solutions';

export default function Solutions() {
  return (
    <section id="solutions" className="py-16 px-6 text-white">
      <div className="max-w-[2600px] mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">
          Solutions
        </h2>
        {/* FLEX WRAP CONTAINER, NO SCROLL */}
        <div className="w-4/5 mx-auto">
          <div
            className="grid grid-cols-1 md:grid-cols-5 gap-6 w-full justify-center items-stretch"
            aria-label="Products list grid container"
          >
            {solutions.map((module, idx) => (
              <div
                key={idx}
                className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-md flex flex-col items-center gap-6 h-full text-center"
              >
                <i
                  className={`${module.iconClass} text-6xl text-blue-400 mx-auto`}
                />
                <h3 className="text-2xl font-bold text-white mx-auto">
                  {module.title}
                </h3>
                {/* Per-line icon support */}
                {Array.isArray(module.body) ?
                  (
                    typeof module.body[0] === 'object' &&
                    module.body[0] !== null
                  ) ?
                    <ul className="mt-2 space-y-4 w-full">
                      {module.body.map((item, i) => (
                        <li
                          key={i}
                          className="flex flex-row items-center items-start gap-4"
                        >
                          <i
                            className={`${item.icon} text-2xl text-blue-400`}
                            aria-hidden="true"
                          />
                          <span className="text-lg text-gray-300 font-medium text-left">
                            {item.text}
                          </span>
                        </li>
                      ))}
                    </ul>
                  : <ul className="mt-2 space-y-4 w-full">
                      {module.body.map((line, i) => (
                        <li
                          key={i}
                          className="flex flex-row items-center items-start gap-4"
                        >
                          <i
                            className="fas fa-check text-2xl text-blue-400"
                            aria-hidden="true"
                          />
                          <span className="text-lg text-gray-300 font-medium text-left">
                            {line}
                          </span>
                        </li>
                      ))}
                    </ul>

                : <p className="text-lg text-gray-300 font-medium mx-auto">
                    {module.body}
                  </p>
                }
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
